import { useLocation } from 'react-router-dom'

export type AdminBasePath = '/platform' | '/developer'

/** Resolve `/platform` vs `/developer` from the current route prefix. */
export function useAdminBasePath(): AdminBasePath {
  const { pathname } = useLocation()
  if (pathname.startsWith('/developer')) {
    return '/developer'
  }
  return '/platform'
}

export function adminPath(basePath: AdminBasePath, segment: string): string {
  const trimmed = segment.replace(/^\/+/, '')
  return trimmed ? `${basePath}/${trimmed}` : basePath
}
